import { Outlet } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import FloatingMenu from './FloatingMenu'
import FloatingFooter from './FloatingFooter'
import FeedbackButton from '../FeedbackButton'
import Toast from '../Toast'
import { useUIStore } from '../../stores/uiStore'
import clsx from 'clsx'

export default function MainLayout() {
  const { toastMessage, toastType, hideToast } = useUIStore()

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {/* Top Bar: Menu/Theme + Mascot/Title */}
      <div className="relative flex items-center justify-center py-6 px-8">
        {/* Left: Floating Menu with Theme Toggle */}
        <div className="absolute left-8">
          <FloatingMenu />
        </div>

        {/* Center: Mascot + Title */}
        <div className="flex items-center gap-4">
          <img
            src="/shellby.png"
            alt="Shellby"
            className="w-16 h-16 object-contain"
          />
          <h1 className="text-3xl font-light text-[var(--bbs-text-accent)]">
            help with Shellby
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <main
        className={clsx(
          'flex-1 overflow-auto px-4 sm:px-8 pb-8',
          'flex items-start justify-center',
          'transition-all duration-200'
        )}
      >
        <div className="w-full max-w-5xl xl:max-w-7xl 2xl:max-w-[1600px]">
          <Outlet />
        </div>
      </main>

      {/* Floating Footer (bottom-center) */}
      <FloatingFooter />

      {/* Version Badge (bottom-right) */}
      <div className="fixed bottom-4 right-4 z-30">
        <span
          className="text-xs text-[var(--bbs-text-quaternary)] bg-white/5 px-3 py-1.5 backdrop-blur-sm"
          style={{ borderRadius: 'var(--bbs-radius-sm)' }}
        >
          v{__APP_VERSION__}.{__BUILD_NUMBER__}
        </span>
      </div>

      {/* Feedback Button (bottom-left) */}
      <FeedbackButton />

      {/* Toast notifications */}
      <AnimatePresence>
        {toastMessage && (
          <Toast
            message={toastMessage}
            type={toastType}
            onClose={hideToast}
          />
        )}
      </AnimatePresence>
    </div>
  )
}
